exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".commentComposer__input p.is-editor-empty:first-child::before{content:attr(data-empty-text);float:left;padding-left:.4rem;color:#c0bfbf;pointer-events:none;height:0;font-style:italic;font-size:1.8rem}.ProseMirror:focus{outline:none;border:none}", ""]);

// exports
